module.exports = __webpack_public_path__ + "img/290.39216762.jpg";